import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
  Polyline,
} from "@react-google-maps/api";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import "./LiveItv.css";
import "react-datepicker/dist/react-datepicker.css";

const GoogleMapComponent = () => {
  const [equipments, setEquipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);
  const [vehiclePath, setVehiclePath] = useState([]);

  // ✅ Use `useJsApiLoader` to ensure Google Maps API is loaded
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c",
  });

  useEffect(() => {
    GetData();
  }, []);

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://ctas.live/backend/api/get/equipments"
      );
      setEquipments(response.data.data); // Assuming response.data.data contains an array of equipment
    } catch (error) {
      console.error("Error fetching equipment data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEquipmentClick = () => {
    if (selectedVehicle) {
      openEquipmentRoute(selectedVehicle, selectedDate, fromTime, toTime);
    }
  };

  const openEquipmentRoute = async (
    equipment,
    date = null,
    fromStr = null,
    toStr = null
  ) => {
    setSelectedVehicle(equipment);
    setShowModal(true);

    try {
      let url = `https://ctas.live/backend/api/get/equipment/location/${equipment.id}?`;

      if (date) {
        url += `&date=${date}`;
      }
      if (fromStr) {
        url += `&start=${fromStr}`;
      }
      if (toStr) {
        url += `&end=${toStr}`;
      }

      const response = await axios.get(url);
      console.log("API equipment history response:", response.data);

      const history = response.data?.data?.moves;
      if (Array.isArray(history)) {
        setVehiclePath(history);
      } else {
        setVehiclePath([]);
      }
    } catch (error) {
      console.error("Failed to load route:", error);
      setVehiclePath([]);
    }
  };

  const containerStyle = {
    width: "96%",
    height: "70vh",
  };

  const center = {
    lat: 28.5116, // Default latitude
    lng: 77.2878, // Default longitude
  };

  const CustomMarker = ({ position, number }) => {
    return (
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <div
          style={{
            position: "relative",
            width: "50px",
            height: "50px",
            backgroundImage: "url(/w.png)",
            backgroundSize: "cover",
            textAlign: "center",
            lineHeight: "50px",
            fontSize: "16px",
            fontWeight: "bold",
            color: "white",
            borderRadius: "5%",
            border: "2px solid blue",
          }}
        >
          {number}
        </div>
      </OverlayView>
    );
  };

  // ✅ Prevent rendering until Google Maps is fully loaded
  if (!isLoaded) return <p>Loading map...</p>;

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="row">
                {showModal && (
                  <div className="custom-modal-overlay">
                    <div className="custom-modal">
                      <div className="modal-header">
                        <h3>
                          {selectedVehicle?.equipment_name} - Movement History
                        </h3>{" "}
                        {/* Change for equipment name */}
                        <button
                          className="modal-close-btn"
                          onClick={() => {
                            setShowModal(false);
                            setVehiclePath([]);
                          }}
                        >
                          ×
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="input-row">
                          <div className="input-group">
                            <label>Date</label>
                            <input
                              type="date"
                              onChange={(e) => setSelectedDate(e.target.value)}
                            />
                          </div>
                          <div className="input-group">
                            <label>From Time</label>
                            <input
                              type="time"
                              onChange={(e) => setFromTime(e.target.value)}
                            />
                          </div>
                          <div className="input-group">
                            <label>To Time</label>
                            <input
                              type="time"
                              onChange={(e) => setToTime(e.target.value)}
                            />
                          </div>
                          <button
                            className="apply-btn"
                            onClick={handleEquipmentClick}
                          >
                            Apply
                          </button>
                        </div>

                        <div className="map-box">
                            {/* {JSON.stringify(vehiclePath)} */}
                          <GoogleMap
                            mapContainerStyle={{
                              width: "100%",
                              height: "400px",
                            }}
                            center={{
                              lat: vehiclePath.length
                                ? parseFloat(vehiclePath[0].unlocklatitude)
                                : center.lat,
                              lng: vehiclePath.length
                                ? parseFloat(vehiclePath[0].unlocklongitude)
                                : center.lng,
                            }}
                            zoom={17}
                            mapTypeId="satellite"
                          >
                            {vehiclePath.map((loc, idx) => {
                              const isLast = idx === vehiclePath.length - 1;
                              const lat = parseFloat(loc.unlocklatitude);
                              const lng = parseFloat(loc.unlocklongitude);

                              return isLast ? (
                                <OverlayView
                                  key={idx}
                                  position={{ lat, lng }}
                                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "80px",
                                      height: "50px",
                                      backgroundImage: "url(/rst.png)",
                                      backgroundSize: "cover",
                                      textAlign: "center",
                                      lineHeight: "50px",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      color: "white",
                                      borderRadius: "5%",
                                      border: "2px solid blue",
                                    }}
                                  >
                                    {selectedVehicle?.equipid}{" "}
                                    {/* Show equipment ID */}
                                  </div>
                                </OverlayView>
                              ) : (
                                <Marker
                                  key={idx}
                                  position={{ lat, lng }}
                                  icon={{
                                    url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                                    scaledSize: new window.google.maps.Size(
                                      10,
                                      10
                                    ),
                                  }}
                                />
                              );
                            })}

                            {vehiclePath.length > 1 && (
                              <Polyline
                                path={vehiclePath.map((loc) => ({
                                  lat: parseFloat(loc.unlocklatitude),
                                  lng: parseFloat(loc.unlocklongitude),
                                }))}
                                options={{
                                  strokeColor: "#00BFFF",
                                  strokeOpacity: 0.8,
                                  strokeWeight: 4,
                                }}
                              />
                            )}
                          </GoogleMap>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-4">
                  <h4 className="text-center text-primary">Equipments List</h4>
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <th>S.No.</th>
                              <th>Equipment Name</th>
                              <th>Current Lat lang</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {equipments?.map((equipment, i) => (
                              <tr key={equipment.id}>
                                <td>{i + 1}</td>
                                <td>{equipment.equipment_name}</td>
                                <td>
                                  {equipment.latitude}, {equipment.longitude}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                      setSelectedVehicle(equipment); // Set selected vehicle
                                      setShowModal(true); // Open modal
                                      openEquipmentRoute(equipment); // Load initial route
                                    }}
                                  >
                                    Map
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-8">
                  <h4 className="text-center text-primary">
                    Equipments Location
                  </h4>
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={17.5}
                    mapTypeId="satellite"
                  >
                    {equipments.map((equipment, index) => (
                      <CustomMarker
                        key={index}
                        position={{
                          lat: parseFloat(equipment.latitude),
                          lng: parseFloat(equipment.longitude),
                        }}
                        number={equipment.equipment_name}
                      />
                    ))}
                  </GoogleMap>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoogleMapComponent;
